import { MPCLocalStorageService } from "../../local-storage-service";
import { Product } from "../../../../Models/Product.generated";

export module MPCColorsField {
    import ProductComparisonModelManager = MPCLocalStorageService.ProductComparisonModelManager;

    export class ColorsField {
        private colors: HTMLElement;
        private productComparisonModelManager: ProductComparisonModelManager;
        private selectedColorSavKey: string;
        private categoryName: string;

        public init(colorContainer: HTMLElement, categoryName: string): void {
            this.colors = colorContainer;
            this.productComparisonModelManager = ProductComparisonModelManager.instance;
            this.categoryName = categoryName;

            this.registerEvents();
        }

        private registerEvents(): void {
            const colors: NodeListOf<HTMLElement> = this.colors.querySelectorAll('.color-container');
            const colorsArray: Array<HTMLElement> = Array.prototype.slice.call(colors);

            for (const color of colorsArray) {
                const savKey: string = color.getAttribute('data-salesarticlevariantkey');
                const colorIcon: HTMLElement = color.querySelector('.color-icon');
                colorIcon.addEventListener('click', ()=>{this.changeProductVariant(savKey);});

                color.addEventListener('keydown', (event: any) => {
                    // prevent page jump down on Space btn., click
                    if (event.code === 'Space') {
                        event.preventDefault(); 
                        this.changeProductVariant(savKey);
                    }

                    if (event.code === 'Enter') {
                        this.changeProductVariant(savKey);
                    }

                    if(!window.shell.tabNav)
                        return;
            
                    if (event.code === 'ArrowRight' && event.target.nextElementSibling) {
                        window.shell.tabNav.focus(event.target.nextElementSibling);
                    }
            
                    if (event.code === 'ArrowLeft' && event.target.previousElementSibling) {
                        window.shell.tabNav.focus(event.target.previousElementSibling);
                    }
                });


                if(colorIcon.classList.contains('selectedColor')) {
                    this.selectedColorSavKey = savKey
                }
            }
        }

        public colorsContent(): string {
            const colors: NodeListOf<HTMLElement> = this.colors.querySelectorAll('.color-container');
            const colorsArray: Array<HTMLElement> = Array.prototype.slice.call(colors);
            const colorCodes = colorsArray.map(x => x.getAttribute('data-colorcode'));
            const colorCodesJoined = colorCodes.join();
            return colorCodesJoined;
        }

        private async changeProductVariant(savKey: string): Promise<void> {
            // prepare new url:
            let currentUrl: string = window.location.href;

            // prepare new url:
            currentUrl = currentUrl.replace(this.selectedColorSavKey, savKey);

            // remove old product from local storage:
            const removed: Product = this.productComparisonModelManager.removeProduct(this.categoryName, this.selectedColorSavKey);

            const origin = removed ? removed.origin : "Deeplink";
            const originNavigationKeyPath = removed ? removed.originNavigationKeyPath : undefined;

            // add new one:
            const productAdded = await this.productComparisonModelManager.addProductBySavKey(savKey, "Unknown", origin, 
                originNavigationKeyPath);

            if(productAdded)
                // refresh page with new url:
                location.replace(currentUrl);
        }
    }
}